export default __webpack_public_path__ + "static/media/star.inline.b3bbf876.svg";